export default __webpack_public_path__ + "static/media/login.bc76322f.jpg";